export const CHOOSE_SKILLS_MESSAGE = 'Agrega las competencias para evaluar';
export const CHOOSE_LEVEL_MESSAGE = 'Escoge el nivel';

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/constants/messages.constants.js